const TOOLTIP_OFFSET_PX = 12;
const WINDOW_MARGIN_PX = 15;
const HOVER_DELAY_MS = 400;
const TRANSITION_DURATION_MS = 200;

export { HOVER_DELAY_MS, TOOLTIP_OFFSET_PX, TRANSITION_DURATION_MS, WINDOW_MARGIN_PX };
//# sourceMappingURL=constants.js.map
